import { createListenerMiddleware } from '@reduxjs/toolkit';
import { logger } from 'common/services';

import { techCheckApi } from './techcheckApi';

import type { RootState } from 'store';

export const techCheckApiListener = createListenerMiddleware<RootState>();

techCheckApiListener.startListening({
  matcher: techCheckApi.endpoints.postTechCheckResult.matchFulfilled,
  effect: ({ meta }) => {
    logger.info('[TechCheck] Result sent successfully', { data: meta.arg.originalArgs });
  },
});

techCheckApiListener.startListening({
  matcher: techCheckApi.endpoints.postTechCheckResult.matchRejected,
  effect: ({ error, payload, meta }) => {
    logger.error(error, { extra: { data: meta.arg.originalArgs, response: payload } });
  },
});
